import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";
import { queryClient } from "../../queryClient.ts";
import { Urls } from "../../urls.ts";

export const useClearNotifications = () => {
  const { token } = useAuth();
  const fetch = useFetch();

  return useMutation({
    mutationFn: () => {
      const response = fetch(`${Urls.Notifications}`, {
        method: "DELETE"
      }, true, token);

      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ["notifications"]});
    },
    onError: (error) => {
      toast.error(error?.message || "Error clearing notifications");
    },
  });
};
